import axios from "axios";
import { API_BASE_URL, API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";
//const countryId =localStorage.getItem("country_Id");
import { toast } from "react-toastify";
const getToken = () => {
  return localStorage.getItem("token");
};
 
export const AllLoadingEquipment = async (zoneId, circleId, wardId, shift) => {
  try {
    // Construct the query parameters
    const params = new URLSearchParams();
   
    if (zoneId) params.append('zoneId', zoneId);
    if (circleId) params.append('circleId', circleId);
    if (wardId) params.append('wardId', wardId);
    if (shift) params.append('ShiftId', shift);
 
    const response = await axiosInstance.get(
      `${API_BASE_URL1}LoadingEquipment/GetAllLoadingEquipmentDetails?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
export const AddLoadEquipmentDetails = async (driverData) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL1 + `LoadingEquipment/AddLoadingEquipment`,
      driverData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const UpdateLoadEquipmentDetails = async (driverData) => {
  try {
    const response = await axiosInstance.put(
      API_BASE_URL1 + `LoadingEquipment/UpdateLoadingEquipment`,
      driverData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
 
    // const successMessage = 'Driver Details Updated Successfully'
    // toast.success(successMessage, {
    //     position: 'top-right',
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // })
 
    // if (!response.ok) {
    //   throw new Error("Failed to add Shift");
    // }
 
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const getDriverById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `driver/getById/${id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const AllLoadingEquipmentClearenceReport = async (
  StartDate,
  endDate,
  OwnerTypeId,
  vehicleTypeId,
  LoadingEquipmentId
) => {
  const ownerId = OwnerTypeId === null ? '' : OwnerTypeId;
  const loadingId = LoadingEquipmentId === null ? '' : LoadingEquipmentId;
  const vehicleId = vehicleTypeId === null ? '' : vehicleTypeId;
 
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `LoadingEquipmentReport/LoadingEquipmentClearanceReport?startDate=${StartDate}&endDate=${endDate}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}&LoadingEquipmentId=${loadingId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
 
export const AllLoadingEquipmentDeploymentSummaryReport = async (
  StartDate,
  endDate,
  shiftId,
  ownerTypeId ,
  vehicleTypeId,
) => {
  const shiftIds = shiftId === null ? '' : shiftId;
  // const loadingId = loadingEquipmentId === null ? '' : loadingEquipmentId;
  const ownerId = ownerTypeId === null ? '' : ownerTypeId;
  const vehicleId = vehicleTypeId === null ? '' : vehicleTypeId;
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `LoadingEquipmentReport/LoadingEquipmentDeploymentReport?startDateTime=${StartDate}&endDateTime=${endDate}&shiftId=${shiftIds}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
export const AllLoadingEquipmentContractorReport = async (Month, ownerType) => {
  console.log(Month);
  console.log(ownerType);
  try {
    // const {Month,ownerType}=requestData
    const response = await axiosInstance.get(API_BASE_URL1 + `LoadingEquipmentReport/GetContractorDetailsLoadingEquipmentReport?OwnerTypeId=${ownerType}&MonthYear=${Month}`,
    {
      headers:{
        Authorization: `Bearer ${getToken()}`
      }
    }  
    );
    return response.data;
  } catch (error) {
    throw error;
 
  }
};
 
export const AllLoadingEquipmentCertificationReport = async (
  StartDate,
  endDate,
  ownerTypeId,
  vehicleTypeId,
  loadingEquipmentId,
  shiftId
) => {
  const ownerId = ownerTypeId === null ? '' : ownerTypeId;
  const loadingId = loadingEquipmentId === null ? '' : loadingEquipmentId;
  const vehicleId = vehicleTypeId === null ? '' : vehicleTypeId;
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `LoadingEquipmentReport/LoadingEquipmentCertificationReport?startDate=${StartDate}&endDate=${endDate}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}&LoadingEquipmentId=${loadingId}&ShiftId=${shiftId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
export const LoadingEquipmentInnerCertificationReport = async (
  startDate,
  endDate,
  ownerTypeId,
  loadingEquipmentId,
  shiftId,
  zoneId,
  circleId,
  vehicleTypeId,
) => {
  const params = new URLSearchParams();
  if (startDate) params.append('StartDate', startDate);
  if (endDate) params.append('EndDate', endDate);
  if (ownerTypeId) params.append('OwnerTypeId', ownerTypeId);
  if (loadingEquipmentId) params.append('LoadingEquipmentId', loadingEquipmentId);
  if (shiftId) params.append('ShiftId', shiftId);
  if (zoneId) params.append('ZoneId', zoneId);
  if (circleId) params.append('CircleId', circleId);
  if (vehicleTypeId) params.append('VehicleTypeId', vehicleTypeId);
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `LoadingEquipmentReport/DeployedLoadingEquipmentDetails?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};